import type { FaireProductEntity } from "../../entity_types/product";

export const p_f3iagauv: FaireProductEntity = {
  token: "p_f3iagauv",
  type: "product",
  name: "Sandalwood Rose - Incense Sticks",
  brandToken: "b_a9b3b023",
  brandName: "P.F. Candle Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/e538a896f50f0164b406a55996c73ffae056756bef3c96f23a524c480d2f9ac4.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e14b4aa9e6ee15ea04747cbbf5ce26fbfb9e22fecd6766b4febf6c9a22113d83.jpeg",
    "https://cdn.faire.com/fastly/eb2e5cc868916f61acf68cd1be13ebafb8dede4e21b353d5b63acc0dd65374ef.jpeg",
    "https://cdn.faire.com/fastly/dcf251b4db8351b2edd624e8c187b03f6a2d8696d5f8b2412ac397924d4c2344.jpeg",
    "https://cdn.faire.com/fastly/9d0bd272bd3218e678e2ad4d572062a04d096c083b603c5391706273149cb761.jpeg",
    "https://cdn.faire.com/fastly/c49631d3764c8627019b9c648e9fbe03227a92b230c0814d52d2c721eefc2c95.jpeg",
  ],
  priceDollars: 5,
  description:
    'New York meets Los Angeles. Our take on a unisex floral. Notes of cashmere rose, oud, and sandalwood. \n\nOur hand-dipped charcoal incense quickly transforms a room: transformative smoke uplifts the space while our signature scents linger for hours even after extinguishing.\n\nEach stick burns for 1 hour; depending on room size, scent longevity lasts between 2-4 hours. 15 sticks in a plastic sleeve inside of each kraft package, measuring 10.75" long each.',
  tags: [],
  msrpDollars: 11,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-07-01T21:36:02.528Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
